import type {
    CloverNormalizedGatewayTransactionDetails,
    CloverTransactionDetailsPaymentBody,
    CloverTransactionDetailsRequestHeaders,
} from './clover-transaction-details.types';

export const CloverTransactionStatusOutcome = {
    FOUND: 'found',
    MISSING: 'missing',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CloverTransactionStatusOutcome =
    (typeof CloverTransactionStatusOutcome)[keyof typeof CloverTransactionStatusOutcome];

export interface CloverTransactionStatusRequestDetails {
    readonly method: 'GET';
    readonly path: '/v1/payments/external/{externalPaymentId}';
    readonly externalPaymentId: string;
    readonly headers: CloverTransactionDetailsRequestHeaders;
}

export interface CloverPaymentExternalResponseBody extends CloverTransactionDetailsPaymentBody {
    readonly externalPaymentId?: string;
}

export interface CloverNormalizedTransactionStatusLookupResult {
    readonly gateway_transaction_details: CloverNormalizedGatewayTransactionDetails;
}

export type CloverTransactionStatusResponseDetails =
    | {
          readonly outcome: typeof CloverTransactionStatusOutcome.FOUND;
          readonly httpStatus: 200;
          readonly rawDetails: CloverPaymentExternalResponseBody;
          readonly normalizedDetails: CloverNormalizedGatewayTransactionDetails;
      }
    | {
          readonly outcome: typeof CloverTransactionStatusOutcome.MISSING;
          readonly httpStatus: number;
          readonly rawDetails: unknown;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CloverTransactionStatusOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly rawDetails: unknown;
          readonly message: string;
      };
